// ==================== USE ORGANIZATIONS HOOK ====================
// Multiple organizations: the logged-in customer's organizations and the one chosen in
// the header dropdown (shown as accounts). Screens read the chosen organization as their
// filter and as the place new records are created. A customer with one organization sees
// every screen exactly as before. Sub-accounts never get organization choices (no request
// is made).

import { useContext } from 'react';
import { OrganizationsContext, type OrganizationsContextType } from '../contexts/organizations';

export function useOrganizations(): OrganizationsContextType {
  const context = useContext(OrganizationsContext);
  if (!context) {
    throw new Error('useOrganizations must be used within an OrganizationsProvider');
  }
  return context;
}
